<!-- 设施设备管理 -->
<template>
   <div class='page_content'>
      <subComponents ref="showSelectData"></subComponents>
      <div class="page_content_top">
         <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
         <div class="page_content_top_line">
            <vSearch @searchData="searchData" :flagList="[]" @openSearchs="openSearch" :getRequestData=getRequestData v-if="pageShowData.jurHead" :searchList=pageShowData.jurHead.jurconfigform>
            </vSearch>
         </div>
      </div>

      <div class="page_content_center">
         <el-table size="mini" v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border @selection-change="selecDataAction" style="width: 100%"
                   highlight-current-row>
            <el-table-column label="选择操作" width="80">
               <template slot-scope="scope">
                  <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                     <i class="el-icon-thumb"></i>
                  </el-radio>
               </template>
            </el-table-column>
            <el-table-column v-if="tableValye.isShow == 1" v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey" show-overflow-tooltip :prop="tableValye.entityField"
                             :label="tableValye.showField">
               <template slot="header">
                  <div>
                     <el-tooltip :content="tableValye.showField" placement="top">
                        <div class="long_title"><span>{{ tableValye.showField }}</span></div>
                     </el-tooltip>
                  </div>
               </template>
               <template slot-scope="scope">
                  <el-tag size="mini" v-if="tableValye.entityField == 'activestatus'">
                     {{ scope.row.fmActivestatus == 0 ? '停用' : '启用' }}
                  </el-tag>
                  <span v-else-if="tableValye.entityField == 'updateTime'">
                     <span v-if="scope.row[tableValye.entityField]">
                        {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                     </span>
                  </span>
                  <span v-else-if="tableValye.entityField == 'createTime'">
                     <span v-if="scope.row[tableValye.entityField]">
                        {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                     </span>
                  </span>
                  <span v-else>
                     {{ scope.row[tableValye.entityField] }}
                  </span>
               </template>
            </el-table-column>
         </el-table>
      </div>

      <div class="page_content_bottom">
         <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>

      </div>
      <!-- 数据操作窗口 -->
      <el-drawer :close-on-press-escape="true" title="我是标题" :visible.sync="dataActionBox.showStatus" :with-header="false" :append-to-body="true" custom-class="drawer_box" :direction="dataActionBox.openMode" size="100%">
         <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
               <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="(val) => { mxHeight = val }">
                  <template slot="tabs" slot-scope="scope">
                     <div class="table_content_box">
                        <!-- 设施设备 -->
                        <div v-if="scope.index == 0">
                           <el-form class="baseForm" label-width="150px" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                              <el-row>
                                 <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow == 1" :prop="formOneValue.entityField"
                                               :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform"
                                               :key="formOneKey">
                                    <!-- 库房 -->
                                    <el-select v-if="formOneValue.entityField == 'stId'" v-model="sendDataInfo[formOneValue.entityField]">
                                       <el-option v-for="(storageRoomValue, storageRoomKey) in storageRoomList" :key="storageRoomKey" :label="storageRoomValue.stName" :value="storageRoomValue.stId">
                                       </el-option>
                                    </el-select>
                                    <!-- 备注 -->
                                    <el-input v-else-if="formOneValue.entityField == 'fmRemarks'" type="textarea" v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"
                                              clearable></el-input>
                                    <el-input v-else v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength" clearable></el-input>
                                 </el-form-item>
                              </el-row>
                           </el-form>
                        </div>
                     </div>
                  </template>
               </v-tabs>
            </el-card>
            <div class="foot">
               <div>
                  <el-button type="primary" @click="initActionBox('sendDataInfo')">取消</el-button>
                  <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 0">保存</el-button>
                  <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 1">保存</el-button>
               </div>
            </div>
         </div>
      </el-drawer>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
         <SearchScheme ref="searchScheme" :id="seId" :smId="smId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <!-- 自定义设计 -->
      <customDesign ref="customDesign"></customDesign>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../byComponents/SearchScheme.vue";
export default {
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme
   },
   data() {
      //这里存放数据
      return {
         tableHeight: 0,
         getRequestData: {
         },
         returnData: {
            pages: 0, // 总页数
            total: 0, // 总条数
            pageNum: 0, // 当前页数
            list: []
         },

         buttonList: [],
         dataActionBox: {
            showStatus: false,
            openMode: 'ltr' || 'rtl',
            boxTitle: '新增' || '编辑',
            actionType: 0, // 0新增，1修改
         },
         showTabs: 'tabsOne',
         sendDataInfo: {
            fmId: 0,
            fmName: "",
            stId: 0,
            stName: "",
            mne: "",
            barcode: "",
            spec: "",
            manufacturer: "",
            placeorigin: "",
            fmRemarks: "",
            creater: 0,
            fmrModifyer: "",
            fpInternalcode: "",
            fpSituation: "",
            fpUnitmeasurement: "",
            fpColor: "",
            fpMinilength: "",
            fpMiniwidth: "",
            fpMiniheight: "",
            fpMinivolume: "",
            fpMiniweight: "",
            "activestatus": "",
            "createTime": 0,
            "fmCode": "",
            "fmReserves1": "",
            "fmReserves2": "",
            "fmReserves3": "",
            "fmReserves4": "",
            "fmReserves5": "",
            "fmReserves6": "",
            "updateTime": 0
         },
         selectedDataList: [],
         selectedDataIndex: 0,
         pageShowData: [],
         formDataList: [],
         storageRoomList: [], //库房
         dictionariesData: {},
         exId: "",
         seId: "",
         ceshi: "",
         dialogTitle: "",
         seWidth: "",
         height: "",
         exTitle: "",
         seTitle: "",
         seWidth: "",
         exWidth: "",
         sField: "",
         parentSearchData: {},
         DialogVisible: false,
         DialogExtract: false,
         seType: '',
         smId: '',
         tabForm: [],
         mxForm: [],
         footForm: [],

      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      "sendDataInfo.fmName"() {
         this.sendDataInfo.mne = this.$common.createPinyinCode(this.sendDataInfo.fmName, this.sendDataInfo.mne)
      },
   },
   //方法集合
   methods: {
      changeInputModel(val) {
         console.log(val);
         if (val != "" || val != undefined) {
            this.DialogVisible = false;
            this.paramValue(val)
         }
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(",");
         arr.forEach((item) => {
            this.getRequestData[item] = val[item];
         });
      },
      getSeWidth(e) {
         console.log(e);
         this.seWidth = e + "%";
      },
      getWidth(e) {
         console.log(e);
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         console.log(e);
         this.seTitle = e;
      },
      getExtractName(e) {
         console.log(e);
         this.exTitle = e;
      },
      // 检索Id, 索引(表格中), 标识
      openSearch(sId, index, type, sField) {
         this.DialogVisible = true
         this.seId = sId
         this.sField = sField
         this.parentSearchData[type] = this.getRequestData[type]
      },
      isShowData(name, value) {
         this.sendDataInfo[name] = value
      },
      getPageInfo() {
         var ss = parent.getMenuInfo(this.$route.path)
         // console.log(ss.jurId)
         this.getDataTest(ss.jurId)
      },

      // 获取数据列表
      async getDataTest(ids) {
         let responseData = await this.$http.getJur({
            ids: [ids]
         })
         if (responseData.status == 200) {
            this.pageShowData = responseData.result
            this.formDataList = this.pageShowData.jurFormVoList
            this.showTabs = this.formDataList[0].jciName
            var obj = {}
            if (this.pageShowData.jurHead) {
               obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
            } else {
               obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
            }
            for (const key in obj) {
               this.$set(this.getRequestData, key, obj[key])
            }
            this.getDataList();
            this.getButtonList();

         } else {
            this.$message({
               message: responseData.message,
               type: 'error'
            });
         }
      },
      selecDataAction(data) {
         this.selectedDataList = data
      },
      // 获取数据详情
      getDataDateils() {
         var olddataInfo = this.returnData.list[this.selectedDataIndex]
         if (!olddataInfo) {
            this.$message({
               message: '请先选中要操作的数据',
               type: 'error'
            });
            return false
         }
         var dataInfo = JSON.parse(JSON.stringify(olddataInfo));
         for (let key in dataInfo) {
            this.$set(this.sendDataInfo, key, dataInfo[key])
         }
         return true
      },
      init() {
         for (let key in this.sendDataInfo) {
            if (key == 'facilitiespacking' || key == 'facilitiesfinance') {
               for (let key1 in this.sendDataInfo[key]) {
                  this.sendDataInfo[key][key1] = ''
               }
            } else this.sendDataInfo[key] = ''
         }
         this.sendDataInfo.fmCreater = this.$store.getters.getUserInfo.opmId
         this.sendDataInfo.ffIntaxrate = 0
         this.sendDataInfo.ffOuttaxrate = 0
      },
      initActionBox() {
         this.$confirm('确定取消新增吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
         }).then(() => {
            this.dataActionBox.actionType = 0
            this.dataActionBox.showStatus = false
            this.init()
            this.$refs.sendDataInfo.resetFields();
         }).catch(() => { });
      },
      openActionBox(cate) {
         this.filterMainField()
         this.init()
         if (cate == 0) {
            this.dataActionBox.boxTitle = '新增信息'
            this.dataActionBox.openMode = 'ltr'
         } else {
            this.dataActionBox.boxTitle = '编辑信息'
            this.dataActionBox.openMode = 'rtl'
            if (this.getDataDateils() == false) {
               return false
            }
         }
         this.dataActionBox.actionType = cate
         this.dataActionBox.showStatus = true
      },
      async sendDataAction(sendDataInfo) {
         console.log(this.$refs);
         console.log(this.$refs['facilitiespacking'])
         this.$refs['sendDataInfo'].validate((valid) => {
            if (valid) {
               this.sub()
            } else {
               this.$message({
                  message: '请完善设施设备信息',
                  type: 'error'
               });
               return false;
            }
         });
      },
      async sub() {
         if (this.dataActionBox.actionType == 0) {
            var responseData = await this.$http.addEquipment(this.sendDataInfo)
         } else {
            let sendData = JSON.parse(JSON.stringify(this.sendDataInfo))
            var responseData = await this.$http.editEquipment(sendData)
         }
         if (responseData.status == 200) {
            this.init()
            this.$message({
               message: '操作成功',
               type: 'success'
            });
            this.dataActionBox.showStatus = false
            if (this.dataActionBox.actionType == 0) {
               this.setDataPageNumber(1)
            } else {
               this.getDataList()
            }

         } else {
            this.$message({
               message: responseData.message,
               type: 'error'
            });
         }
      },
      // 动作集合
      actionSet(actionData) {
         switch (actionData.actionType) {
            case 0:
               this.openActionBox(actionData.actionType)
               break;
            case 1:
               this.openActionBox(actionData.actionType)
               break;
            case 2:
               this.delDataAction()
               break;
            case 15:
               this.openFormDesign()
               break;
         }
      },
      openFormDesign() {
         let pathInfo = parent.getMenuInfo(this.$route.path)
         this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
      },
      // 数据搜索
      searchData() {
         this.getRequestData.page = 1
         this.getDataList()
      },
      // 数据翻页
      setDataPageNumber(val) {
         this.getRequestData.page = val
         this.getDataList()
      },

      // 切换显示条数
      setDataPageSize(val) {
         this.getRequestData.page = 1
         this.getRequestData.rows = val
         this.getDataList()
      },


      // 获取数据列表
      async getDataList() {
         if (this.getRequestData.fmName == '') this.getRequestData.fmId = ''
         let responseData = await this.$http.getEquipment(this.getRequestData)
         if (responseData.status == 200) {
            this.returnData.list = responseData.result.list
            this.returnData.pages = responseData.result.pages
            this.returnData.total = responseData.result.total
            this.returnData.pageNum = responseData.result.pageNum
            this.selectedDataList = []
         } else {
            this.$message({
               message: responseData.message,
               type: 'error'
            });
         }
      },

      // 获取字典数据
      async getPartDictionariesData() {
         let responseData = await this.$http.getPartDictionariesData({
            ids: [14, 15, 10, 25, 11, 13, 5]
         })
         if (responseData.status == 200) {
            this.dictionariesData = responseData.result
         } else {
            this.$message({
               message: responseData.message,
               type: 'error'
            });
         }
      },



      // 获取所有可用库房列表
      async getAllStorageRoom() {
         let responseData = await this.$http.getAllStorageRoom()
         if (responseData.status == 200) {
            this.storageRoomList = responseData.result
         } else {
            this.$message({
               message: responseData.message,
               type: 'error'
            });
         }
      },

      // 删除数据
      delDataAction() {
         var dataInfo = this.returnData.list[this.selectedDataIndex]
         if (!dataInfo) {
            this.$message({
               message: '请先选中要操作的数据',
               type: 'error'
            });
            return false
         }
         this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
         }).then(async () => {
            var delData = {
               ids: [dataInfo.fmId]
            }
            let responseData = await this.$http.delEquipment(delData)
            if (responseData.status == 200) {
               this.$message({
                  type: 'success',
                  message: '删除成功!'
               });

               this.getDataList()
            } else {
               this.$message({
                  message: responseData.message,
                  type: 'error'
               });
            }

         }).catch(() => {
            this.$message({
               type: 'info',
               message: '已取消删除'
            });
         })

      },

      // 获取按钮权限
      async getButtonList() {
         this.buttonList = await this.$common.getActionButton()
         
      },
// 过滤表单不同类型
      filterMainField() {
         var mainFormList = []
         this.formDataList.forEach(item => {
            if (item.jciType == 1) {
               mainFormList.push(item)
            } else if (item.jciType == 2) {
               this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
            } else if (item.jciType == 3) {
               this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
            }
         })
         mainFormList.forEach((key, i) => {
            this.tabForm[i] = JSON.parse(JSON.stringify(key))
            this.tabForm[i].jurconfigform = []
            for (let index = 0; index < key.jurconfigform.length; index++) {
               if (key.jurconfigform[index].isShow == 1) this.tabForm[i].jurconfigform.push(key
                  .jurconfigform[index])
            }
         })
         var arr = []
         var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
         for (let key in obj) {
            this.$set(this.sendDataInfo, key, obj[key])
         }
         this.$set(this.sendDataInfo, "fmCreater", this.$store.getters.getUserInfo.opmId)
         this.$set(this.sendDataInfo, "ffIntaxrate", 0)
         this.$set(this.sendDataInfo, "ffOuttaxrate", 0)
      }
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.getPageInfo()
      this.getAllStorageRoom()
      this.getPartDictionariesData()

   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() {

   },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.table_content_tag {
   margin-right: 1rem;
}

/* .el-tabs--border-card_new{
	height: 85vh;
	overflow-y: scroll;
} */
</style>